var socketStore = {
  state: {
    socket: null,
    roomId: "",
    userId: "",
  },
  setSocketStore(socket, roomId, userId = "") {
    this.state.socket = socket;
    this.state.roomId = roomId;
    this.state.userId = userId;
  },
  setUserId(userId) {
    this.state.userId = userId;
  },
  clearSocketStore() {
    this.state.socket = null;
    this.state.roomId = "";
    this.state.userId = "";
  },
  emit(command, data) {
    this.state.socket.emit(command, this.state.roomId, this.state.userId, data);
  }
};

export default socketStore;
